import { useGreeterVenueApi } from "@greeter/matter";
import { TicketEventOverviewPage } from "./TicketEventOverviewPage";

export function TicketEventOverviewPageApiHandler() {
  const api = useGreeterVenueApi();
  return <TicketEventOverviewPage api={api.api} />;
}
